import instanceQuery from 'graphql/queries/supplier/PurchaseRefundPostingPreviewQuery.graphql';
import fragment from 'graphql/fragments/nominal/NominalPostingPreviewFragment.graphql';

const PurchaseRefundPostingPreview = {
  type: 'PostingResponse',
  formTitle: 'Nominal Posting Preview',
  instance: instanceQuery,
  fragment,
};

export default PurchaseRefundPostingPreview;
